import Vue from 'vue'
import VueRouter from 'vue-router'
import {resolve} from "ali-oss/shims/url";

Vue.use(VueRouter)

const routes = [{
    path: "/",
    title: "登录",
    component: resolve => require(['@/pages/LoginModule/Login.vue'], resolve)
},
    {
        name: "register",
        path:"/register",
        title:"注册",
        component:resolve => require(['@/pages/LoginModule/Register.vue'], resolve)
    },
    {
        name: "welcome",
        path:"/welcome",
        title:"welcome",
        component:resolve => require(['@/pages/LoginModule/Welcome.vue'], resolve)
    },
    {
        name: "guide",
        path:"/guide",
        title:"guide",
        component:resolve => require(['@/pages/LoginModule/Guide.vue'], resolve)
    },

    {
        path: "/",
        meta: {
            title: '主页',
            keepAlive: true
        },
        component: resolve => require(['@/pages/tabModule/Tabbar.vue'], resolve),
        children: [{
            path: "home",
            name: "home",
            meta: {
                title: '首页'
            },
            component: resolve => require(['@/pages/tabModule/Home.vue'], resolve),
        },
            {
                path: "searchPage",
                name: "searchPage",
                title: "搜索",
                meta: {
                    title: '搜索结果',
                    breadcrumb: [],
                    keepAlive: true

                },
                component: resolve => require(['@/pages/tabModule/SearchPage.vue'], resolve),
            },
            {
                path: "expendMaterial",
                name: "expendMaterial",
                title: "耗材",
                meta: {
                    title: '耗材详情',
                    breadcrumb: [],
                    keepAlive: false

                },
                component: resolve => require(['@/pages/tabModule/expendMaterial.vue'], resolve),
            },

            {
                path: "myPurchase",
                name: "myPurchase",
                meta: {
                    title: '购物车',
                    breadcrumb: ['我的选购']
                },
                component: resolve => require(['@/pages/HomePage/MyPurchase.vue'], resolve),
            },
            // {
            //     path: "borrowInfo",
            //     name: "borrowInfo",
            //     title: "我的借用记录",
            //     meta: {
            //         title: '我的借用记录',
            //         breadcrumb: [['搜索','searchPage']]
            //     },
            //     component: resolve => require(['@/pages/HomePage/BorrowInfo.vue'], resolve),
            // },
            {
                path: "overBook",
                name: "overBook",
                title: "下单",
                meta: {
                    title: '订单确认',
                    breadcrumb: [['搜索', 'searchPage'], ['我的选购', 'myPurchase']]
                },
                component: resolve => require(['@/pages/HomePage/OverBook.vue'], resolve),
            },
            {
                path: "borrowInfo",
                name: "borrowInfo",
                meta: {
                    title: '领用筐',
                    breadcrumb: ['我的操作']
                },
                component: resolve => require(['@/pages/HomePage/BorrowInfo.vue'], resolve),
            },
            {
                path: "borrowInfoFree",
                name: "borrowInfoFree",
                meta: {
                    title: '领用筐',
                    breadcrumb: ['我的操作']
                },
                component: resolve => require(['@/pages/HomePage/BorrowInfoFree.vue'], resolve),
            },
            {
                path: "myOrder",
                name: "myOrder",
                meta: {
                    title: '我的订单',
                    breadcrumb: ['我的选购']
                },
                component: resolve => require(['@/pages/Personal/MyOrder.vue'], resolve),
            },
            {
                path: "goodsDetails/:id",
                name: "goodsDetails",
                meta: {
                    title: '商品详情',
                    breadcrumb: [['订单统计管理', 'orderCensus']]
                },
                component: resolve => require(['@/pages/Personal/GoodsDetails.vue'], resolve),
            },
            {
                path: "goodsDetailsGrzx/:id",
                name: "goodsDetailsGrzx",
                meta: {
                    title: '订单详情',
                    breadcrumb: [['我的订单', 'myOrder']]
                },
                component: resolve => require(['@/pages/Personal/GoodsDetailsGrzx.vue'], resolve),
            },
            {
                path: "orderReview",
                name: "orderReview",
                meta: {
                    title: '订单审核',
                    breadcrumb: [['权限管理']]
                },
                component: resolve => require(['@/pages/Personal/OrderReview.vue'], resolve),
            },
            {
                path: "goodsDetailsSh/:id",
                name: "goodsDetailsSh",
                meta: {
                    title: '查看商品',
                    breadcrumb: [['订单审核', 'orderReview']]
                },
                component: resolve => require(['@/pages/Personal/GoodsDetailsSh.vue'], resolve),
            },
            {
                path: "reviewGoods",
                name: "reviewGoods",
                meta: {
                    title: '查看商品',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/Personal/ReviewGoods.vue'], resolve),
            },
            {
                path: "cabinetRun",
                name: "cabinetRun",
                meta: {
                    title: '柜机管理',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/CabinetRun/CabinetRun.vue'], resolve),
            },
            {
                path: "cabinetRun10",
                name: "cabinetRun10",
                meta: {
                    title: '柜机管理',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/CabinetRun/CabinetRun10.vue'], resolve),
            },
            {
                path: "reagentRun",
                name: "reagentRun",
                meta: {
                    // keepAlive: true,
                    title: '试剂管理',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/CabinetRun/ReagentRun.vue'], resolve),
            },
            {
                path: "reagentRunFree",
                name: "reagentRunFree",
                meta: {
                    // keepAlive: true,
                    title: '试剂管理',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/CabinetRun/ReagentRunFree.vue'], resolve),
            },
            {
                path: "material",
                name: "material",
                meta: {
                    // keepAlive: true,
                    title: '耗材管理',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/CabinetRun/Material.vue'], resolve),
            },
            {
                path: "cabinetRecord",
                name: "cabinetRecord",
                meta: {
                    title: '柜机日志',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/DataCensus/CabinetRecord.vue'], resolve),
            },
            {
                path: "orderCensus",
                name: "orderCensus",
                meta: {
                    title: '订单采购统计',
                    breadcrumb: ['数据统计']
                },
                component: resolve => require(['@/pages/DataCensus/OrderCensus.vue'], resolve),
            },
            {
                path: "reagentReceive",
                name: "reagentReceive",
                meta: {
                    title: '试剂领用记录',
                    breadcrumb: ['数据统计']
                },
                component: resolve => require(['@/pages/DataCensus/ReagentReceive.vue'], resolve),
            },
            {
                path: "location",
                name: "location",
                title: "我的地址",
                meta: {
                    title: '我的地址',
                    breadcrumb: ['个人中心']
                },
                component: resolve => require(['@/pages/Personal/Location.vue'], resolve),
            },
            {
                path: "myLend",
                name: "myLend",
                meta: {
                    title: '组内转用',
                    breadcrumb: ['我的操作']
                },
                component: resolve => require(['@/pages/Personal/MyLend.vue'], resolve),
            },
            {
                path: "myLendOther",
                name: "myLendOther",
                meta: {
                    title: '借用他组',
                    breadcrumb: ['我的操作']
                },
                component: resolve => require(['@/pages/Personal/MyLendOther.vue'], resolve),
            },
            {
                path: "account",
                name: "account",
                meta: {
                    title: '账号管理',
                    breadcrumb: ['权限管理']
                },
                component: resolve => require(['@/pages/Power/account.vue'], resolve),
            },
            {
                path: "account2",
                name: "account2",
                meta: {
                    title: '账号审核',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/Power/account2.vue'], resolve),
            },
            {
                path: "quotaManagement",
                name: "quotaManagement",
                meta: {
                    title: '我的额度',
                    breadcrumb: ['我的选购']
                },
                component: resolve => require(['@/pages/Power/QuotaManagement.vue'], resolve),
            },
            {
                path: "quotaManagement2",
                name: "quotaManagement2",
                meta: {
                    title: '额度分配',
                    breadcrumb: ['权限管理']
                },
                component: resolve => require(['@/pages/Power/QuotaManagement2.vue'], resolve),
            },
            {
                path: "buyLimit",
                name: "buyLimit",
                meta: {
                    title: '购买限制管理',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/Commodity/BuyLimit.vue'], resolve),
            }, {
                path: "mine",
                name: "mine",
                meta: {
                    title: '我的资料',
                    breadcrumb: ['个人中心']
                },
                component: resolve => require(['@/pages/Personal/Mine.vue'], resolve),
            },
            {
                path: "addReagent",
                name: "addReagent",
                meta: {
                    // keepAlive: true, // 需要缓存
                    title: '新增试剂',
                    breadcrumb: [['试剂管理', 'reagentRun']]
                },
                component: resolve => require(['@/pages/CabinetRun/AddReagent.vue'], resolve),
            },
            {
                path: "addReagentFree",
                name: "addReagentFree",
                meta: {
                    // keepAlive: true, // 需要缓存
                    title: '新增试剂',
                    breadcrumb: [['试剂管理', 'reagentRunFree']]
                },
                component: resolve => require(['@/pages/CabinetRun/AddReagentFree.vue'], resolve),
            },
            {
                path: "todos",
                name: "todos",
                meta: {
                    title: '待办事项',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/HomePage/Todos.vue'], resolve),
            },
            {
                path: "print",
                name: "print",
                meta: {
                    title: '打印托盘码',
                    breadcrumb: [['柜机管理', 'cabinetRun']]
                },
                component: resolve => require(['@/pages/CabinetRun/PrintLocation.vue'], resolve),
            },
            {
                path: "printPage",
                name: "printPage",
                meta: {
                    title: '打印',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/CabinetRun/PrintPage.vue'], resolve),
            },
            {
                path: "reagentPublic",
                name: "reagentPublic",
                meta: {
                    title: '试剂公开',
                    breadcrumb: ['权限管理']
                },
                component: resolve => require(['@/pages/Power/ReagentPublic.vue'], resolve),
            },
            {
                path: "myBorrow",
                name: "myBorrow",
                meta: {
                    title: '我的领用',
                    breadcrumb: ['我的操作']
                },
                component: resolve => require(['@/pages/Personal/MyBorrow.vue'], resolve),
            },
            {
                path: "orderDataAnaly",
                name: "orderDataAnaly",
                meta: {
                    title: '数据图表',
                    breadcrumb: [['数据统计','orderCensus']]
                },
                component: resolve => require(['@/pages/DataCensus/OrderDataAnaly.vue'], resolve),
            },

            {
                path: "searchLog",
                name: "searchLog",
                meta: {
                    title: '搜索日志',
                    breadcrumb: [['系统日志']]
                },
                component: resolve => require(['@/pages/DataCensus/SearchLog.vue'], resolve),
            },
            {
                path: "pdaInventory",
                name: "pdaInventory",
                meta: {
                    title: 'PDA盘点',
                    breadcrumb: []
                },
                component: resolve => require(['@/pages/Pda/PdaInventory.vue'], resolve),
            },

            {
                path: "cabinetRecordFree",
                name: "cabinetRecordFree",
                meta: {
                    title: '柜机日志',
                    breadcrumb: ['系统日志']
                },
                component: resolve => require(['@/pages/DataCensus/CabinetRecordFree.vue'], resolve),
            },
        ]
    },
// {
//     path: "/printPage",
//     title: "打印",
//     component: resolve => require(['@/pages/CabinetRun/PrintPage.vue'], resolve)
// }

]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {

    if (to.path === '/') return next()
    if (to.path === '/welcome') return next()
    if (to.path === '/register') return next()
    const tokenStr = window.localStorage.getItem('TOKEN')
    if (!tokenStr) return next('/')
    next()
})


export default router